import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { Utils } from './../../utils';

export interface DialogData {
    title: string;
    item: any;
    noButtonText: string;
    yesButtonText: string;
    type: 'news' | 'others';
}

@Component({
    selector: 'app-popup-dialog',
    templateUrl: './popup-dialog.html',
    styleUrls: ['./popup-dialog.scss']
})
export class PopupDialogComponent {
    result: DialogData;
    utils = Utils;

    constructor(
        public dialogRef: MatDialogRef<PopupDialogComponent>,
        @Inject(MAT_DIALOG_DATA) private _data: DialogData
    ) {

        if (_data != null) {
            this.result = this._data;
        }

    }

}
